import { Button, Nav, NavItem, Collapse } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./StaffSidebar.css";

const navigation = [
  {
    title: "Manage Properties",
    icon: "bi bi-building",
    hasDropdown: true,
    children: [
      {
        title: "My Properties",
        href: "/provider-properties",
        icon: "bi bi-building",
      },
      {
        title: "Custom Amenities",
        href: "/provider-dashboard/LocalAmenities",
        icon: "bi bi-lightbulb",
      }
    ]
  },
  {
    title: "Bookings",
    href: "/provider-dashboard/bookings",
    icon: "bi bi-calendar-check",
  },
  {
    title: "Apply to Host",
    href: "/alerts",
    icon: "bi bi-textarea-resize",
  },
/*   {
    title: "Badges",
    href: "/badges",
    icon: "bi bi-patch-check",
  },
  {
    title: "Buttons",
    href: "/buttons",
    icon: "bi bi-hdd-stack",
  },
  {
    title: "Cards",
    href: "/cards",
    icon: "bi bi-card-text",
  },
  {
    title: "Grid",
    href: "/grid",
    icon: "bi bi-columns",
  },
  {
    title: "Table",
    href: "/table",
    icon: "bi bi-layout-split",
  },
  {
    title: "Forms",
    href: "/forms",
    icon: "bi bi-textarea-resize",
  },
  {
    title: "Breadcrumbs",
    href: "/breadcrumbs",
    icon: "bi bi-link",
  },
  {
    title: "About",
    href: "/about",
    icon: "bi bi-people",
  }, */
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState({});
  
  const toggleDropdown = (index) => {
    setDropdownOpen(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  
  const closeSidebar = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  return (
    <div className="p-3">
      {/* Mobile close button - only visible on small screens */}
      <div className="d-flex justify-content-end d-lg-none mb-2">
        <Button
          color="link"
          size="sm"
          className="text-dark p-1"
          onClick={closeSidebar}
          style={{ border: 'none' }}
        >
          <i className="bi bi-x-lg" style={{ fontSize: '1.2rem', color: '#000' }}></i>
        </Button>
      </div>
      
      <div className="d-flex align-items-center">
        {/* <Logo /> */}
      </div>
      <div className="pt-4 mt-2">
        <Nav vertical className="sidebarNav">
          {navigation.map((navi, index) => (
            <NavItem key={index} className="sidenav-bg">
              {navi.hasDropdown ? (
                <>
                  <div
                    className="nav-link py-3 d-flex justify-content-between align-items-center dropdown-parent"
                    style={{ 
                      color: "#000", 
                      cursor: "pointer",
                      backgroundColor: dropdownOpen[index] ? "rgb(230 238 248)" : "transparent",
                      fontSize: navi.title.length > 12 ? "12px" : "inherit",
                      fontWeight: navi.title.length > 12 ? "600" : "normal"
                    }}
                    onClick={() => toggleDropdown(index)}
                  >
                    <div>
                      <i className={navi.icon} style={{ color: "#000" }}></i>
                      <span className="ms-3 d-inline-block">{navi.title}</span>
                    </div>
                    <i className={`bi ${dropdownOpen[index] ? 'bi-chevron-up' : 'bi-chevron-down'}`} 
                       style={{ color: "#000" }}></i>
                  </div>
                  <Collapse isOpen={dropdownOpen[index]}>
                    <div style={{ backgroundColor: "rgb(230 238 248)", borderRadius: "4px", margin: "0 8px" }}>
                      {navi.children && navi.children.map((child, childIndex) => (
                        <Link
                          key={childIndex}
                          to={child.href}
                          className="nav-link py-2 ps-3"
                          style={{ 
                            color: "#000", 
                            fontSize: child.title.length > 12 ? "12px" : "0.9rem",
                            fontWeight: child.title.length > 12 ? "600" : "normal",
                            backgroundColor: "transparent"
                          }}
                          onClick={() => navigate(child.href)}
                        >
                          <i className={child.icon} style={{ color: "#000" }}></i>
                          <span className="ms-2 d-inline-block">{child.title}</span>
                        </Link>
                      ))}
                    </div>
                  </Collapse>
                </>
              ) : (
                <Link
                  to={navi.href}
                  className={
                    location.pathname === navi.href
                      ? "nav-link py-3"
                      : "nav-link py-3"
                  }
                  style={{ 
                    color: "#000",
                    fontSize: navi.title.length > 12 ? "12px" : "inherit",
                    fontWeight: navi.title.length > 12 ? "600" : "normal"
                  }}
                >
                  <i className={navi.icon} style={{ color: "#000" }}></i>
                  <span className="ms-3 d-inline-block">{navi.title}</span>
                </Link>
              )}
            </NavItem>
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;
